import socialMedia from './social-media'
export default socialMedia
